import React from 'react';
import OverlayContext from './Components/LoadingOverlay/OverlayContext';

export interface WithOverlayProps {
  overlay: {
    showOverlay: () => void;
    hideOverlay: () => void;
  };
}

function withOverlay<T>(Component: React.ComponentType<T & WithOverlayProps>) {
  return (props: Omit<T, keyof WithOverlayProps>) => {
    const context = React.useContext(OverlayContext);

    if (!context) {
      throw new Error('withOverlay must be used within an OverlayProvider');
    }

    const { showOverlay, hideOverlay } = context;

    return <Component {...(props as T)} overlay={{ showOverlay, hideOverlay }} />;
  };
}

export default withOverlay;

